import axios from "axios";
const API_URL = "/auth";
;
const logout = () => {
  localStorage.removeItem("token");
};
const authService = {
  logout,
};
export default authService;

export const canApproveParent = () => {
  try {
    const userDetails = JSON.parse(localStorage.getItem("user_detail"));
    return userDetails?.email_address?.toLowerCase() === 'salman@ayekart.com';
  } catch {
    return false;
  }
}